'use strict';
import {isDev} from '../utils/IsDev';
import {projectConfig} from '../project-info/projectConfig';

const env = isDev()
  ? 'staging' // set to 'dev'/'staging' for appropriate server
  : 'prod';

let d;
if (env === 'staging') {
  d = projectConfig.stageAPIURL;
} else if (env === 'prod') {
  d = projectConfig.prodAPIURL;
} else if (env === 'dev') {
  try {
    d = projectConfig.devAPIURL;
    // uncomment to use local server
    // let localServer = require('../../localServer');
    // if (localServer && localServer.default && localServer.default.url) {
    //   d = localServer.default.url;
    // }
  } catch (error) {
    d = projectConfig.devAPIURL;
  }
}
// d = projectConfig.stageAPIURL;
export const DOMAIN = d; // used for API and external links

export const SITE = {
  lostpassword: `${DOMAIN}reset_password/`,
};

// scrape open graph data for previews. Required if hasOpenGraphPreviews is true. 
// This is a paid service, so be careful with usage. See ApiKeys. 
export const OPENGRAPH_API = 'https://opengraph.io/api/1.1/site';

export const ENVIRONMENT = env;
